import getConfig from 'next/config'
import { headers } from '../lib/fetch'

const {
  publicRuntimeConfig: { LEAP_API },
} = getConfig()

const leapFetcher = async (endpoint, params) => {
  return fetch(`${LEAP_API}/${endpoint}`, {
    ...params,
  })
    .then(data => {
      if (!data.ok) {
        throw data
      }
      return data.json()
    })
    .catch(error => {
      if (error instanceof Error) {
        throw Error('Something went wrong. Try again')
      }

      return error.json().then(errorJson => {
        throw Error(errorJson.message)
      })
    })
}

export const getAllDcProgrammeDetails = async (ctx, hasAuth) => {
  return leapFetcher('programmes/2', {
    method: 'get',
    headers: headers(ctx, hasAuth),
  }).then(data => (data ? data : {}))
}

export const getDcMembershipDetail = async ctx => {
  return leapFetcher('memberships?programmeId=2', {
    method: 'get',
    headers: headers(ctx, true),
  }).then(data => (data ? data : {}))
}

// for switching packages without making payment immediately
export const dcAutoRenewal = (membershipId, body) => {
  return leapFetcher(`memberships/${membershipId}/auto-renewal`, {
    method: 'patch',
    headers: headers(null, true),
    body: JSON.stringify(body),
  })
}

export const getDcMembershipStatus = async ctx => {
  return leapFetcher('memberships/status', {
    method: 'get',
    headers: headers(ctx, true),
  }).then(data => (data ? data : {}))
}
